/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ModuleIn
 */
export interface ModuleIn {
    /**
     * 
     * @type {number}
     * @memberof ModuleIn
     */
    module: number;
}

export function ModuleInFromJSON(json: any): ModuleIn {
    return ModuleInFromJSONTyped(json, false);
}

export function ModuleInFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModuleIn {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'module': json['module'],
    };
}

export function ModuleInToJSON(value?: ModuleIn | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'module': value.module,
    };
}


